// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore"; // Import Firestore as well

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAl_jetV5JBWXTcw2QpJzg1-8iWF-xKvfY",
  authDomain: "shopping-list-e4510.firebaseapp.com",
  projectId: "shopping-list-e4510",
  storageBucket: "shopping-list-e4510.firebasestorage.app",
  messagingSenderId: "546309799785",
  appId: "1:546309799785:web:435d256e80ce5ea5bac7f8",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// You can also export the app instance if needed
export default app;
